export default __webpack_public_path__ + "static/media/NextArrowDark.11407552.svg";